import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-login-worktocloud',
  templateUrl: './login-worktocloud.component.html',
  styleUrls: ['./login-worktocloud.component.css'],
})
export class LoginWorktocloudComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
